<template>
  <div class="header">
    <img :src="logo" :alt="companyInformation.logo_name" class="logo" />
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'ChatHeader',
  props: {
    logo: String,
    title: String,
    companyInformation: Object
  }
}
</script>

<style scoped>
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-lg, 16px);
  width: 100%;
  max-width: var(--welcome-max-width, 640px);
}

.logo {
  height: 8rem;
  max-width: 280px;
  object-fit: contain;
}

.title {
  font-size: var(--text-xl, 1.75rem);
  font-family: var(--font-display, 'TT Ramillas Trl', Georgia, serif);
  font-weight: var(--font-semibold, 600);
  color: var(--text-primary, #1C1C1C);
  text-align: center;
}
</style>
